import { Component } from '@angular/core';

@Component({
  selector: 'app-program-buttons',
  templateUrl: './program-buttons.component.html',
  styleUrls: ['./program-buttons.component.css']
})
export class ProgramButtonsComponent {
}
